import './MoreWorkspaceOptions.scss';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Dropdown, IconButton, ListDivider, Menu, MenuButton, MenuItem } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { TrashIcon } from '../../../../design/static/icons/TrashIcon';
import { EnableFor } from '../../../containers/EnableForRole';
import { UpdateWorkspaceTimeZoneMenuItemContainer } from '../sub/UpdateWorkspaceTimeZone/containers/UpdateWorkspaceTimeZoneDropdownItem.container';
import { useWorkspacePermissions } from '../workspaces.permissions';

interface IProps {
  isEncrypted: boolean;
  encryptionKeyUrl: string;
  workspaceName: string;
  onRenameClicked: () => void;
  onChangeOwnerClicked: () => Promise<void>;
  onDeleteClicked: () => void;
  onResetClicked: () => void;
}

export const MoreWorkspaceOptions = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const permissions = useWorkspacePermissions();

  const canChangeOwner = permissions.canChangeOwner();
  const canDelete = permissions.canDelete();
  const canReset = permissions.canReset();

  return (
    <div className='workspace-more-options'>
      <Dropdown>
        <MenuButton
          slots={{ root: IconButton }}
          slotProps={{ root: { variant: 'topbar', color: 'neutral' } }}
        >
          <FontAwesomeIcon icon='ellipsis-v' />
        </MenuButton>
        <Menu>
          <MenuItem onClick={props.onRenameClicked}>{t('rename_workspace')}</MenuItem>
          <EnableFor hasPermission={canChangeOwner}>
            <MenuItem
              onClick={() => {
                void props.onChangeOwnerClicked();
              }}
            >
              {t('change_workspace_owner')}
            </MenuItem>
          </EnableFor>
          <UpdateWorkspaceTimeZoneMenuItemContainer />
          {props.isEncrypted && (
            <a
              href={props.encryptionKeyUrl}
              download={`${props.workspaceName}.key`}
            >
              <MenuItem>{t('download_key')}</MenuItem>
            </a>
          )}
          <ListDivider />
          <EnableFor hasPermission={canReset}>
            <MenuItem onClick={props.onResetClicked}>
              <FontAwesomeIcon
                icon={faRefresh}
                fixedWidth
              />
              {t('reset_workspace')}
            </MenuItem>
          </EnableFor>
          <EnableFor hasPermission={canDelete}>
            <MenuItem onClick={props.onDeleteClicked}>
              <TrashIcon /> {t('delete_workspace')}
            </MenuItem>
          </EnableFor>
        </Menu>
      </Dropdown>
    </div>
  );
});
